export enum InstrumentsOrderingEnum {
  Name = 'Name',
  Created = 'DateCreated',
}
